import { BILLS_PAYMENT_TYPE } from 'app-constants'
import { isBefore } from './date'

export function isValidPaymentRecurring(isPaymentRecurring, paymentType, dueDate) {
  const isOverdue = isBefore(dueDate, new Date())

  if (paymentType === BILLS_PAYMENT_TYPE.CREDIT_CARD && isOverdue) {
    return false
  }

  return isPaymentRecurring
}
